import React from "react"
import { Button, Grid } from '@material-ui/core'

import Loader from '../Loader/Loader'

import pickAppStyle from "./pickAppStyle.jsx"
import withStyles from "@material-ui/core/styles/withStyles"

import moment from 'moment'

const Slots = ({classes, slots, daySelected, selectedSlotId, setSelectedSlot, handleConfirmSlot,loading}) => {

  const slotList = slots && slots.map((item, idx) => {
    return (
      <Grid container item xs={12} sm={6} md={4} className={classes.slotContainer} justify='center' key={idx}>
        <Button classes={{root: `${classes.greyButton} ${selectedSlotId === item.appointment.mapadore_event_id && classes.slotSelected}`}} onClick={() => setSelectedSlot(item)}>
          {moment(item.appointment.time.startTime).format('HH:mm')} - {moment(item.appointment.time.finishTime).format('HH:mm')}
        </Button>
      </Grid>
    );
  });

  return (
    <Grid container justify='center' direction='column' alignItems='center'>
      <Grid item className={classes.subTitle + ' ' + classes.titleDark} style={{margin: '50px'}}>
        Orari disponibili per il giorno {daySelected.format('DD MMMM YYYY')}
      </Grid>
      {loading && <Loader color='dark'/>}
      {!loading && (slotList && slotList.length > 0 ? 
      <Grid container>
        <Grid container justify='center'>
          {slotList}
        </Grid>
        <Grid container justify='center' style={{marginTop: '100px'}}>
          <Button disabled={!selectedSlotId} classes={{root: classes.greyButton, disabled: classes.buttonDisabled}} onClick={() => handleConfirmSlot()}>
            Conferma
          </Button>
        </Grid>
      </Grid>
      :
      <Grid container justify='center' style={{minHeight: '150px'}} alignContent='center'>
        <Button disabled classes={{root: classes.greyButton + ' ' + classes.noSlots, disabled: classes.noSlots}}>
          Non ci sono slot disponibili per il giorno selezionato
        </Button>
      </Grid>)}
    </Grid>
  );

}

export default withStyles(pickAppStyle)(Slots)
